const INITIAL_STATE = {
  lang: "ko",
  sharedResult: undefined,
  refer: "n",
  entranceTime: 0,
  answer: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
}

export default INITIAL_STATE
